export var LANGUAGE_OPTIONS = [
    { label: 'English', value: 'EN' },
    { label: 'Spanish', value: 'ES' },
    { label: 'Portuguese', value: 'PT' },
];
export var SPANISH_LANGUAGE_COUNTRIES = new Set([
    'andorra',
    'argentina',
    'bolivia',
    'chile',
    'colombia',
    'costa rica',
    'cuba',
    'dominican republic',
    'ecuador',
    'el salvador',
    'equatorial guinea',
    'guatemala',
    'honduras',
    'mexico',
    'nicaragua',
    'panama',
    'paraguay',
    'peru',
    'spain',
    'uruguay',
    'vatican city',
    'venezuela',
]);
export var PORTUGUESE_LANGUAGE_COUNTRIES = new Set([
    'angola',
    'brazil',
    'cabo verde',
    'guinea-bissau',
    'guinea bissau',
    'mozambique',
    'portugal',
    'sao tome and principe',
    'timor-leste',
    'timor leste',
]);
export var normalizeCountryToken = function (value) {
    if (value === void 0) { value = ''; }
    return String(value).trim().toLowerCase();
};
export var getDefaultLanguageForCountry = function (country) {
    if (country === void 0) { country = ''; }
    var normalizedCountry = normalizeCountryToken(country);
    if (PORTUGUESE_LANGUAGE_COUNTRIES.has(normalizedCountry)) {
        return 'PT';
    }
    if (SPANISH_LANGUAGE_COUNTRIES.has(normalizedCountry)) {
        return 'ES';
    }
    return 'EN';
};
